<template>
  <div id="title">
    <van-nav-bar
      :title="title"
      :left-text="
        $route.name == '商品详情' || $route.name == '文章详情' ? '返回' : ''
      "
      :left-arrow="isShow"
      :border="false"
      @click-left="onClickLeft"
      :fixed="true"
    >
      <template
        #right
        v-if="$route.name == '商品详情' || $route.name == '文章详情'"
      >
        <van-icon name="myShare" @click="showIn = true" />
      </template>
    </van-nav-bar>
    <div class="showIn" v-if="showIn">
      <div class="iKnow" @click="showIn = false"></div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import bus from '../utils/eventBus'
export default {
  data () {
    return {
      title: '',
      showIn: false,
      newTitle: '',
      isShow: true,
      LeftTest: false,
      routeList: [
        '商品详情',
        '商品分类',
        '登录',
        '注册账号',
        '忘记密码',
        '确认订单',
        '收货地址',
        '添加地址',
        '编辑地址',
        '在线支付',
        '支付成功',
        '积分详情',
        '我的好友',
        '我的收藏',
        '积分商城',
        '积分奖励',
        '积分流水',
        "数据统计",
        '文章',
        '订单',
        '邀请海报',
        '兑换记录',
        '支付成功',
        '个人资料',
        '文章详情',
        '我的库存',
        '库存明细',
        '补货',
        '云仓配货',
        '提货到线下',
        '积分兑换商品详情'
      ]
    }
  },
  watch: {
    $route: {
      handler: function (val, oldval) {
        this.title = ''
        this.newTitle = ''
        this.title = val.name
        if (this.routeList.indexOf(this.$route.name) >= 0) {
          this.isShow = true
        } else {
          this.isShow = false
        }
      }
    },
    deep: true
  },
  methods: {
    onClickLeft () {
      const name = this.$route.name
      if (this.$route.params.rePath) {
        this.$router.push(this.$route.params.rePath)
      } else {
        if (name == '收货地址') {
          this.$router.replace(sessionStorage.getItem('addressParams'))
        } else if (name == '添加地址' || name == '编辑地址') {
          this.$router.replace('/shippingAddress')
        } else if (name == '积分商城') {
          this.$router.replace('/home')
        } else if (name == '兑换记录') {
          this.$router.replace({ name: '积分商城' })
        } else if (name == '支付成功') {
          this.$router.push({
            name: '订单'
          })
        } else if (name == '确认订单' || name == '提货到线下') {
          if (sessionStorage.getItem('backAddress')) {
            sessionStorage.removeItem('backAddress')
          }
          this.$router.back()
        } else if (name == '文章详情' || name == '商品详情') {
          if (this.$route.path != this.$route.fullPath) {
            this.$router.push('/home')
          } else {
            this.$router.back()
          }
        } else {
          this.$router.back()
        }
      }
    }
  }
}
</script>

<style lang='scss' >
// 头部
#title {
  .van-nav-bar__text {
    color: #323233;
    font-size: 0.14rem;
  }
  .showIn {
    background: url("../assets/img/share/img_share@2x.png") no-repeat center
      center;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: 1000;
    .iKnow {
      background: url("../assets/img/share/btn_determine@2x.png") no-repeat
        center center;
      background-size: 1.18rem 0.87rem;
      width: 100%;
      height: 100%;
    }
  }
  .van-nav-bar {
    height: 0.49rem;
    background: #ffffff;
    box-shadow: 0px 5px 10px 0px rgba(210, 83, 16, 0.04);
  }

  .van-tabs__line {
    z-index: 0;
  }

  .van-nav-bar {
    .van-nav-bar__left {
      .van-icon-arrow-left {
        width: 0.1rem;
        height: 0.17rem;
        background-image: url("../assets/img/nav_return@2x.png");
        background-repeat: no-repeat;
        background-size: 0.1rem 0.17rem;
      }

      .van-icon-arrow-left::before {
        content: "";
      }
    }

    .van-nav-bar__title {
      font-size: 0.16rem;
    }

    .van-nav-bar__right {
      .van-icon-myShare {
        width: 0.17rem;
        height: 0.17rem;
        background-image: url("../assets/img/nav_share@2x.png");
        background-repeat: no-repeat;
        background-size: 0.17rem 0.17rem;
      }
    }
  }
}
</style>
